import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/features/object'; // <- at the top of your entry point
import 'core-js/modules/es.array.includes'; // <- at the top of your entry point
import 'core-js/modules/es.array.filter'; // <- at the top of your entry point
import 'core-js/features/promise'; // <- at the top of your entry point
import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'font-awesome/css/font-awesome.min.css';

// const tagManagerArgs = {
//   gtmId: 'GTM-KWDT32',
//   dataLayerName: 'dataLayer'
// };
// TagManager.initialize(tagManagerArgs);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
